function DropdownDivider() {
  return (
    <div className="mx-[5px] mt-[10px] pb-[10px] border-t-[1px] border-dark-op-01 dark:border-light-op-01"></div>
  )
}

export default DropdownDivider
